/* This file is based on `vscode-lean4/vscode-lean4/src/abbreviation/AbbreviationProvider.ts` */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { computed } from 'mobx';
// import { Disposable } from 'vscode';
// import { autorunDisposable } from '../utils/autorunDisposable';
import * as abbreviations from 'lean4/src/abbreviation/abbreviations.json';
import { config } from './config';
/**
 * Answers queries to a database of abbreviations.
 */
var AbbreviationProvider = /** @class */ (function () {
    function AbbreviationProvider() {
        // private readonly disposables = new Array<Disposable>();
        this.cache = {};
        // this.disposables.push(
        // 	autorunDisposable(() => {
        // 		// For the livetime of this component, cache the computed's
        // 		const _ = this.symbolsByAbbreviation;
        // 		// clear cache on change
        // 		this.cache = {};
        // 	})
        // );
    }
    Object.defineProperty(AbbreviationProvider.prototype, "symbolsByAbbreviation", {
        get: function () {
            // There are only like 1000 symbols. Building an index is not required yet.
            return __assign(__assign({}, abbreviations), config.inputModeCustomTranslations);
        },
        enumerable: false,
        configurable: true
    });
    AbbreviationProvider.prototype.getAllAbbreviations = function (symbol) {
        return Object.entries(this.symbolsByAbbreviation)
            .filter(function (_a) {
            var _b = __read(_a, 2), abbr = _b[0], sym = _b[1];
            return sym === symbol;
        })
            .map(function (_a) {
            var _b = __read(_a, 1), abbr = _b[0];
            return abbr;
        });
    };
    AbbreviationProvider.prototype.findSymbolsIn = function (symbolPlusUnknown) {
        var e_1, _a;
        var result = new Set();
        try {
            for (var _b = __values(Object.entries(this.symbolsByAbbreviation)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), abbr = _d[0], sym = _d[1];
                if (symbolPlusUnknown.startsWith(sym)) {
                    result.add(sym);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return __spreadArray([], __read(result.values()), false);
    };
    /**
     * Computes the replacement text for a typed abbreviation (excl. leader).
     * This converts the longest non-empty prefix with the best-matching abbreviation.
     *
     * For example:
     *   getReplacementText("alp") returns "α"
     *   getReplacementText("alp7") returns "α7"
     *   getReplacementText("") returns undefined
     */
    AbbreviationProvider.prototype.getReplacementText = function (abbrev) {
        if (abbrev in this.cache) {
            return this.cache[abbrev];
        }
        var result = this._getReplacementText(abbrev);
        this.cache[abbrev] = result;
        return result;
    };
    AbbreviationProvider.prototype._getReplacementText = function (abbrev) {
        if (abbrev.length === 0) {
            return undefined;
        }
        var matchingSymbol = this.findSymbolsByAbbreviationPrefix(abbrev)[0];
        if (matchingSymbol) {
            return matchingSymbol;
        }
        // Convert the `alp` in `\alp7`
        var prefixReplacement = this.getReplacementText(abbrev.slice(0, abbrev.length - 1));
        if (prefixReplacement) {
            return prefixReplacement + abbrev.slice(abbrev.length - 1);
        }
        return undefined;
    };
    AbbreviationProvider.prototype.getSymbolForAbbreviation = function (abbrev) {
        return this.symbolsByAbbreviation[abbrev];
    };
    AbbreviationProvider.prototype.findSymbolsByAbbreviationPrefix = function (abbrevPrefix) {
        var _this = this;
        var matchingAbbreviations = Object.keys(this.symbolsByAbbreviation).filter(function (abbrev) { return abbrev.startsWith(abbrevPrefix); });
        matchingAbbreviations.sort(function (a, b) { return a.length - b.length; });
        return matchingAbbreviations.map(function (abbr) { return _this.symbolsByAbbreviation[abbr]; });
    };
    __decorate([
        computed
    ], AbbreviationProvider.prototype, "symbolsByAbbreviation", null);
    return AbbreviationProvider;
}());
export { AbbreviationProvider };
